import React, { useContext, useState, useEffect } from 'react'
import { map, get, isEmpty, each, has } from 'lodash'
import Pagination from 'react-js-pagination'
import { BookInfo, MenuContext, UserInfo } from '../../contexts/menuContext'
import { getRelation } from '../../api/getRelation'
import { useHistory } from 'react-router-dom'

const CollectionItemElement = ({ item, id }) => {
  const [book, , , setPage, , setForceScroll] = useContext(BookInfo)
  const [open, setOpen] = useState(false)
  const [list, setList] = useState({})
  const history = useHistory();
  useEffect(() => {
    if (open) {
      getRelation(`/bookreader/toolbox/collection/${id}`).then((data) => {
        setList(data.bookmarks)
      })
    }
    // eslint-disable-next-line
  }, [open])
  return (<div className="collection-info">
    <div className="collection-info-line">
      <svg
        width="1.5rem"
        height="1.5rem"
        fill="currentColor"
        viewBox="-64 0 512 512"
      >
        <path xmlns="http://www.w3.org/2000/svg" d="m324.070312 0h-264.058593c-33.089844 0-60.011719 26.882812-60.011719 59.929688v452.070312l192.066406-125.066406 192.015625 124.4375v-451.441406c0-33.046876-26.921875-59.929688-60.011719-59.929688zm20.003907 437.765625-152.058594-98.542969-152.007813 98.980469v-378.273437c0-10.984376 8.972657-19.921876 20.003907-19.921876h264.058593c11.027344 0 20.003907 8.9375 20.003907 19.921876zm-132.027344-267.730469h70.015625v40.011719h-70.015625v70.011719h-40.011719v-70.011719h-70.011718v-40.011719h70.011718v-70.011718h40.011719zm0 0"/>
      </svg>
      <h5>{item.title}</h5>
      {get(item, 'edit') && <a href={`${item.edit}?destination=${get(window, 'location.pathname')}`}>Edit & Share</a>}
      <button onClick={() => { setOpen(!open) }}>{open ? '-' : '+'}</button>
    </div>
    <div className={`collection-listing ${open ? 'list-open' : 'list-closed'}`}>
      <ul>
        {map(get(list, `[${id}].reference`), (listItem, tpPd) => {

          const chapter = get(book, 'relationships.navigation.chapter');
          const navArray = []
          const menuTreeRecursive = (menuItemGroup) => {
            each(menuItemGroup, (menuItem) => {
              if (!isEmpty(menuItem.children)) {
                menuTreeRecursive(menuItem.children)
              } else if (has(menuItem, 'value.id')) {
                navArray.push(menuItem.value)
              }
            })
          }
          menuTreeRecursive(chapter)
          const find = navArray.find(item => {
            return item.id === tpPd
          })
          return (
            <li className="final-list-item" key={tpPd}>
              <a
                href={listItem.url}
                onClick={(e) => {
                  if (find && get(book, 'page_type') === "chapters") {
                    if (`${listItem.book.id}` === book.id) {
                      e.stopPropagation()
                      e.preventDefault()
                      setPage(tpPd)
                      setForceScroll(true)
                      let targetUrl = get(e.target, 'url', get(book, 'url'))
                      history.push(targetUrl)
                    }
                    return false
                  }
                }}
              >
                <span>{listItem.book.title} </span>
                {listItem.title}
              </a>
            </li>
          )
        })}
      </ul>
    </div>
  </div>)
}

const Collections = () => {
  const [, changeMenuStatus, , changeRightSidebar, userClosedMenu,] = useContext(MenuContext)
  const [user] = useContext(UserInfo)
  const [activeTab, setActiveTab] = useState(get(user, 'id') !== 0)
  const [,, page] = useContext(BookInfo)
  const [collections, setCollections] = useState({})
  const [collectionsShared, setCollectionsShared] = useState({})
  const [pager, setPager] = useState(1)
  const [total, setTotal] = useState(0)
  const [pagerShared, setPagerShared] = useState(1)
  const [totalShared, setTotalShared] = useState(0)
  const pagerLimit = 10
  useEffect(() => {
    setPager(1)
  }, [page])
  useEffect(() => {
    let filtering = ''
    if (isEmpty(filtering)) {
      filtering += `?offset=${(pager - 1) * pagerLimit}&limit=${pagerLimit}`
    } else {
      filtering += `&offset=${(pager - 1) * pagerLimit}&limit=${pagerLimit}`
    }
    let filteringShared = '?'
    if (isEmpty(filteringShared)) {
      filteringShared += `?offset=${(pagerShared - 1) * pagerLimit}&limit=${pagerLimit}`
    } else {
      filteringShared += `&offset=${(pagerShared - 1) * pagerLimit}&limit=${pagerLimit}`
    }

    getRelation(`/bookreader/toolbox/collections${filtering}`).then((data) => {
      setCollections(data.data)
      setTotal(data.total)
    })
    // eslint-disable-next-line
    getRelation(`/bookreader/toolbox/collections${filteringShared}&shared=1`).then((data) => {
      setCollectionsShared(data.data)
      setTotalShared(data.total)
    })
    // eslint-disable-next-line
  }, [pager, pagerShared])
  return (
    <div className="collections-wrapper">
      <div className="collections-header">
        <div
          className="collections-close"
          onClick={() => {
            changeRightSidebar(false)
            changeMenuStatus(!userClosedMenu)
          }}
        ><svg xmlns="http://www.w3.org/2000/svg" id="Outlined" viewBox="0 0 32 32" fill="currentColor">
          <title/>
          <g id="Fill">
            <polygon points="28.71 4.71 27.29 3.29 16 14.59 4.71 3.29 3.29 4.71 14.59 16 3.29 27.29 4.71 28.71 16 17.41 27.29 28.71 28.71 27.29 17.41 16 28.71 4.71"/>
          </g>
        </svg>
        </div>
      </div>
      <div className="collections-wrapper-inner">
        <ul className="nav nav-tabs" id="collectionsTabs" role="tablist">
          {get(user, 'id') !== 0 && <li className="nav-item"><a
            className={`nav-link ${activeTab && 'active'}`}
            data-toggle="tab"
            data-reference="chapters"
            href="#chapters"
            role="tab"
            aria-selected="true"
            onClick={() => {
              setActiveTab(true)
            }}
          >My Collections
          </a>
          </li>}

          <li className="nav-item"><a
            className={`nav-link ${!activeTab && 'active'}`}
            data-toggle="tab"
            data-reference="appendices"
            href="#appendices"
            role="tab"
            aria-selected="true"
            onClick={() => {
              setActiveTab(false)
            }}
          >Shared Collections
          </a>
          </li>
        </ul>

        <div className="tab-content" id="collectionsContent" >
          {get(user, 'id') !== 0 && <div className={`tab-pane ${activeTab && 'active'}`}>
            {parseInt(total) ? map(collections, (item, id) => {
              return <CollectionItemElement key={id} item={item} id={id}/>
            }) : <div className="collection-info">You haven't made any collections yet. You can create collections from within books by bookmarking content.</div>}
            {total > pagerLimit && <Pagination
              activePage={pager}
              itemsCountPerPage={pagerLimit}
              totalItemsCount={parseInt(total, 10)}
              itemClass="page-item"
              linkClass="page-link"
              pageRangeDisplayed={5}
              onChange={(pageNumber) => { setPager(pageNumber) }}
            />}
          </div>
          }
          <div className={`tab-pane ${!activeTab && 'active'}`}>
            {parseInt(totalShared) ? map(collectionsShared, (item, id) => {
              return <CollectionItemElement key={id} item={item} id={id}/>
            }) : <div className="collection-info">There are no collections shared with you at this time.</div>}
            {total > pagerLimit && <Pagination
              activePage={pagerShared}
              itemsCountPerPage={pagerLimit}
              totalItemsCount={parseInt(totalShared, 10)}
              itemClass="page-item"
              linkClass="page-link"
              pageRangeDisplayed={5}
              onChange={(pageNumber) => { setPagerShared(pageNumber) }}
            />}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Collections
